import { formatMoney } from "Helpers/helpFunction"
import moment from "moment"

export const options = (data, time, height, fontSizeLabel) => {
  const tickInterval = parseInt((data?.tradingdate.length / 5).toFixed(0))
  
  const minVnindex = (data?.vnindex?.[0] / 2) || 0
  const minPe = (data?.pe?.[0] / 2) || 0
  return {
    chart: {
      zoomType: 'x',
      backgroundColor: 'transparent',
      height: height,
      spacingLeft: 0,
      spacingRight: 0
    },
    title: {
      text: ''
    },
    xAxis: {
      categories: data?.tradingdate,
      gridLineWidth: 0,
      minorTickWidth: 0,
      minorGridLineWidth: 0,
      lineWidth: 0,
      tickInterval: tickInterval,
      labels: {
        rotation: 0,
        padding: 0,
        formatter: (item) => {
          let day = null
          if (time === '6M') {
            day = moment(item?.value).format('MM/YYYY')
          } else if (time === '1Y') {
            day = moment(item?.value).format('MM/YYYY')
          } else if (time === '2Y') {
            day = moment(item?.value).format('MM/YYYY')
          }
          return day
        },
        style: {
          color: '#ffffff',
          fontSize: '11.5px'
        }
      },
    },
    yAxis: [{
      min: minVnindex,
      tickInterval: 400,
      title: {
        text: 'Điểm',
        margin: 5,
        style: {
          fontSize: '12px',
          color: '#B8B8B8'
        }
      },
      gridLineWidth: 0,
      minorTickWidth: 0,
      labels: {
        padding: 0,
        x: 0,
        y: 0,
        style: {
          color: '#ffffff',
          fontSize: fontSizeLabel,
        },
        formatter: function (res) {
          return res?.value ? formatMoney(res?.value) : '';
        }
      }
    }, {
      min: minPe,
      title: {
        text: 'Lần',
        margin: 5,
        style: {
          fontSize: '12px',
          color: '#B8B8B8'
        }
      },
      gridLineWidth: 0,
      minorTickWidth: 0,
      opposite: true,
      labels: {
        x: 0,
        y: 0,
        style: {
          color: '#ffffff',
          fontSize: fontSizeLabel,
        }
      }
    }],
    legend: {
      enabled: false
    },
    plotOptions: {
      areaspline: {
        lineWidth: 1.5,
      },
      series: {
        states: {
          inactive: {
            opacity: 1
          }
        }
      }
    },
    tooltip: {
      enabled: true,
      shared: true,
      useHTML: true,
      split: true,
      borderRadius: 0,
      borderWidth: 0,
      backgroundColor: '#131313',
      formatter: function () {
        const index = this?.points[0].point.index
        const day = moment(this.x, 'YYYY-MM-DD').format('DD/MM/YYYY')

        return `<div class="ioalomryco">
        <div class="fzlgnzcgwl whlqpruvka">Ngày: ${day} </div>
        <div class="fzlgnzcgwl fzbjtfpdgt">P/E: ${formatMoney(data?.pe?.[index], 2)} </div>
        <div class="fzlgnzcgwl fzbjtfpdgt">VNINDEX: ${formatMoney(data?.vnindex?.[index], 2)} </div>
        </div>`;
      }
    },
    series: [{
      type: 'areaspline',
      data: data?.vnindex,
      lineColor: '#f7931a',
      fillColor: {
        linearGradient: {
          x1: 0,
          y1: 0,
          x2: 0,
          y2: 1
        },
        stops: [
          [0, '#f7931a4f'],
          [1, 'transparent']
        ]
      },
      marker: {
        radius: 4,
        lineColor: '#ffffff',
        fillColor: '#f7931a'
      }
    }, {
      type: 'areaspline',
      yAxis: 1,
      data: data?.pe,
      lineColor: '#2ad03d',
      fillColor: {
        linearGradient: {
          x1: 0,
          y1: 0,
          x2: 0,
          y2: 1
        },
        stops: [
          [0, '#2ad03d52'],
          [1, 'transparent']
        ]
      },
      marker: {
        radius: 4,
        lineColor: '#ffffff',
        fillColor: '#2ad03d'
      }
    }]
  }
}